import { useCallback, useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'
import { Contract } from 'web3-eth-contract'

import {
  getWethContract,
  getFarms,
  getTotalLPWethValue
} from '../../sushi/utils'
import { MINTTOKEN } from '../../constants/bakery'


import useYam from './useYam'
import useBlock from './useBlock'
import { useActiveWeb3React } from '..'
import { poolMasterContract } from '../../userType/poolMasterContract'

export interface StakedValue {
  tokenAmount: BigNumber
  wethAmount: BigNumber
  totalWethValue: BigNumber
  tokenPriceInWeth: BigNumber
  poolWeight: BigNumber
  lpBalanceOfMaster: BigNumber
}

const useAllStakedValue = (tokenName?: string) => {
  const [balances, setBalance] = useState([] as Array<StakedValue>)
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  const wethContact = getWethContract(sushi)
  const block = useBlock()
  const bakeFarms = getFarms(sushi)
  const bakeV2Farms = getFarms(sushi, MINTTOKEN.BAKEV2)
  const petFarms = getFarms(sushi, MINTTOKEN.PET)
  const bPetFarms = getFarms(sushi, MINTTOKEN.BPET)
  const weaponFarms = getFarms(sushi, MINTTOKEN.WEAPON)
  const springFarms = getFarms(sushi, MINTTOKEN.TEN)
  const wsoteFarms = getFarms(sushi, MINTTOKEN.WSOTE)
  const shieldFarms = getFarms(sushi, MINTTOKEN.SHIELD)
  const bryFarms = getFarms(sushi, MINTTOKEN.BRY)
  const pcwsFarms = getFarms(sushi, MINTTOKEN.PCWS)
  const defi100Farms = getFarms(sushi, MINTTOKEN.DEFI100)
  const defi100OLDFarms = getFarms(sushi, MINTTOKEN.DEFI100OLD)
  const bananaFarms = getFarms(sushi, MINTTOKEN.BANANA)
  const warFarms = getFarms(sushi, MINTTOKEN.WAR)
  const war2Farms = getFarms(sushi, MINTTOKEN.WAR2)
  const dieselFarms = getFarms(sushi, MINTTOKEN.DIESEL)
  const mxFarms = getFarms(sushi, MINTTOKEN.MX)
  const aliceFarms = getFarms(sushi, MINTTOKEN.ALICE)
  const dfyFarms = getFarms(sushi, MINTTOKEN.DFY)
  const gfxFarms = getFarms(sushi, MINTTOKEN.GFX)
  const xDittoFarms = getFarms(sushi, MINTTOKEN.XDITTO)
  const sactFarms = getFarms(sushi, MINTTOKEN.SACT)
  const pet3Farms = getFarms(sushi, MINTTOKEN.PET3)
  const hyfiFarms = getFarms(sushi, MINTTOKEN.HYFI)
  const ginuFarms = getFarms(sushi, MINTTOKEN.GINU)
  const levFarms = getFarms(sushi, MINTTOKEN.LEV)
  const bondlyFarms = getFarms(sushi, MINTTOKEN.BONDLY)
  const tctFarms = getFarms(sushi, MINTTOKEN.TCT)
  const tkoFarms = getFarms(sushi, MINTTOKEN.TKO)
  const tkonftStakeFarms = getFarms(sushi, MINTTOKEN.TKONFTSTAKE)
  const bmoncnftStakeFarms = getFarms(sushi, MINTTOKEN.BMONCNFTSTAKE)
  const bmmnftStakeFarms = getFarms(sushi, MINTTOKEN.BMMNFTSTAKE)
  const tko2Farms = getFarms(sushi, MINTTOKEN.TKO2)
  const bnrgFarms = getFarms(sushi, MINTTOKEN.BNRG)
  const tsaFarms = getFarms(sushi, MINTTOKEN.TSA)
  const tlmFarms = getFarms(sushi, MINTTOKEN.TLM)
  const doggyTlmFarms = getFarms(sushi, MINTTOKEN.TLM2)
  const barkTlmFarms = getFarms(sushi, MINTTOKEN.TLM3)
  const tokauTlmFarms = getFarms(sushi, MINTTOKEN.TLM4)
  const bondly2Farms = getFarms(sushi, MINTTOKEN.BONDLY2)
  const toynftStakeFarms = getFarms(sushi, MINTTOKEN.TOYNFTSTAKE)
  const gatTlmFarms = getFarms(sushi, MINTTOKEN.TLM5)
  const wsgFarms = getFarms(sushi, MINTTOKEN.WSG)
  const dogoFarms = getFarms(sushi, MINTTOKEN.DOGO)
  const bethFarms = getFarms(sushi, MINTTOKEN.BETHMASTER)
  const tokauFarms = getFarms(sushi, MINTTOKEN.TOKAU)
  const eggFarms = getFarms(sushi, MINTTOKEN.EGG)
  const kalataFarms = getFarms(sushi, MINTTOKEN.KALATA)
  const donFarms = getFarms(sushi, MINTTOKEN.DON)
  const ntFarms = getFarms(sushi, MINTTOKEN.NT)
  const moniFarms = getFarms(sushi, MINTTOKEN.MONI)
  const nblFarms = getFarms(sushi, MINTTOKEN.NBL)

  let farms: any[]
  let masterContract: Contract = poolMasterContract(sushi, tokenName)
  switch (tokenName) {
    case MINTTOKEN.SHIELD:
      farms = shieldFarms
      break
    case MINTTOKEN.WSOTE:
      farms = wsoteFarms
      break
    case MINTTOKEN.PET:
      farms = petFarms
      break
    case MINTTOKEN.BPET:
      farms = bPetFarms
      break
    case MINTTOKEN.WEAPON:
      farms = weaponFarms
      break
    case MINTTOKEN.BEST:
      farms = weaponFarms
      break
    case MINTTOKEN.TEN:
      farms = springFarms.filter((farm: any) => farm.pid === 19001)
      break
    case MINTTOKEN.BRY:
      farms = bryFarms
      break
    case MINTTOKEN.DEFI100:
      farms = defi100Farms
      break
    case MINTTOKEN.DEFI100OLD:
      farms = defi100OLDFarms
      break
    case MINTTOKEN.BANANA:
      farms = bananaFarms
      break
    case MINTTOKEN.PCWS:
      farms = pcwsFarms
      break
    case MINTTOKEN.WAR:
      farms = warFarms
      break
    case MINTTOKEN.WAR2:
      farms = war2Farms
      break
    case MINTTOKEN.DIESEL:
      farms = dieselFarms
      break
    case MINTTOKEN.MX:
      farms = mxFarms
      break
    case MINTTOKEN.ALICE:
      farms = aliceFarms
      break
    case MINTTOKEN.DFY:
      farms = dfyFarms
      break
    case MINTTOKEN.GFX:
      farms = gfxFarms
      break
    case MINTTOKEN.XDITTO:
      farms = xDittoFarms
      break
    case MINTTOKEN.SACT:
      farms = sactFarms
      break
    case MINTTOKEN.PET3:
      farms = pet3Farms
      break
    case MINTTOKEN.HYFI:
      farms = hyfiFarms
      break
    case MINTTOKEN.GINU:
      farms = ginuFarms
      break
    case MINTTOKEN.LEV:
      farms = levFarms
      break
    case MINTTOKEN.BONDLY:
      farms = bondlyFarms
      break
    case MINTTOKEN.TCT:
      farms = tctFarms
      break
    case MINTTOKEN.TKO:
      farms = tkoFarms
      break
    case MINTTOKEN.TKONFTSTAKE:
      farms = tkonftStakeFarms
      break
    case MINTTOKEN.BMMNFTSTAKE:
      farms = bmmnftStakeFarms
      break
    case MINTTOKEN.TKO2:
      farms = tko2Farms
      break
    case MINTTOKEN.BNRG:
      farms = bnrgFarms
      break
    case MINTTOKEN.TSA:
      farms = tsaFarms
      break
    case MINTTOKEN.TLM:
      farms = tlmFarms
      break
    case MINTTOKEN.TLM2:
      farms = doggyTlmFarms
      break
    case MINTTOKEN.TLM3:
      farms = barkTlmFarms
      break
    case MINTTOKEN.TLM4:
      farms = tokauTlmFarms
      break
    case MINTTOKEN.BONDLY2:
      farms = bondly2Farms
      break
    case MINTTOKEN.TOYNFTSTAKE:
      farms = toynftStakeFarms
      break
    case MINTTOKEN.BMONCNFTSTAKE:
      farms = bmoncnftStakeFarms
      break
    case MINTTOKEN.TLM5:
      farms = gatTlmFarms
      break
    case MINTTOKEN.WSG:
      farms = wsgFarms
      break
    case MINTTOKEN.DOGO:
      farms = dogoFarms
      break
    case MINTTOKEN.BETHMASTER:
      farms = bethFarms
      break
    case MINTTOKEN.TOKAU:
      farms = tokauFarms
      break
    case MINTTOKEN.BAKEV2:
      farms = bakeV2Farms
      break
    case MINTTOKEN.EGG:
      farms = eggFarms
      break
    case MINTTOKEN.KALATA:
      farms = kalataFarms
      break
    case MINTTOKEN.DON:
      farms = donFarms
      break
    case MINTTOKEN.NT:
      farms = ntFarms
      break
    case MINTTOKEN.MONI:
      farms = moniFarms
      break
    case MINTTOKEN.NBL:
      farms = nblFarms
      break
    default:
      farms = bakeFarms
  }

  const fetchAllStakedValue = useCallback(async () => {
    // 这里就打印不出来 bakev2了
    const balances: Array<StakedValue> = await Promise.all(
      farms.map(
        ({
          lpTokenAddress,
          lpContract,
          tokenContract
        }: {
          lpTokenAddress: string
          lpContract: Contract
          tokenContract: Contract
        }) => getTotalLPWethValue(masterContract, wethContact, lpContract, tokenContract, lpTokenAddress)
      )
    )

    setBalance(balances)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, masterContract, sushi])

  useEffect(() => {
    if (account && masterContract && sushi) {
      fetchAllStakedValue()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, block, masterContract, setBalance, sushi])

  return balances
}

export default useAllStakedValue
